const theme = {
  fonts: {
    font1: "Open Sans",
    font2: "Roboto Condensed",
    font3: "Roboto Slab",
  },
  colors: {
    firstLevel: {
      blue1: "#142b47",
      blue2: "#1b3a61",
      blue3: "#225089",
      blue4: "#3068ad",
      blue5: "#0074c1",
      gray1: "#93a4bd",
      blue6: "#35b0cb",
    },
    secondLevel: {
      gray1: "#415a7b",
    },
    thirdLevel: {
      brown1: "#8c6910",
      brown2: "#d2b859",
      light1: "#f0ebdd",
      light2: "#f7f4ed",
      red1: "#e9261d",
    },
    fourthLevel: {
      black1: "#000000",
      gray1: "#333333",
      gray2: "#666666",
      gray3: "#757575",
      gray4: "#c3c3c3",
      gray5: "#cccccc",
      gray6: "#e1e5ea",
      gray7: "#f3f6f9",
    },
  },
};

export default theme;
